import { TranslateService } from '@ngx-translate/core';
import { MonthlyRecurrenceConfigType } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'monthlyRecurrenceType', pure: false, standalone: true })
export class MonthlyRecurrenceTypePipe extends BaseEnumTranslationPipe<MonthlyRecurrenceConfigType> implements PipeTransform {
  protected readonly translationPrefix = 'iss-wo-common.monthly-recurrence';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
